<template>
	<v-container class="publication none-fluid link">
		<banner>Publications</banner>
		<div class="scroll-option-container">
			<span
				v-for="(section, index) in content"
				:key="section.year"
				@click="scrollTo(section.year, index)"
				class="scroll-options"
			>{{ section.year }}</span>
		</div>
		<i class="mdi mdi-format-vertical-align-top up-arrow" @click="goTop" />
		<br />
		<v-expansion-panels multiple v-model="panels" class="mx-auto publications-content">
			<v-expansion-panel
				v-for="section in content"
				:key="section.year"
				expand
				:id="`year-${section.year.substr(0,4)}`"
			>
				<v-expansion-panel-header class="expansion-header">{{ section.year }}</v-expansion-panel-header>
				<v-expansion-panel-content class="expansion-content">
					<div
						v-for="collection in section.children"
						:key="collection.title"
						class="expansion-subsection"
					>
						<h4>{{ collection.title }}</h4>
						<p v-for="paper in collection.papers" :key="paper" v-html="$sanitize(paper)"></p>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import { getAllPublications } from "../../service/research/publications";

export default {
	components: {
		Banner
	},
	data() {
		return {
			panels: [],
			content: []
		};
	},
	mounted() {
		getAllPublications()
			.then(content => {
				this.content = content;
				for (let i = 0; i < content.length; ++i) {
					this.panels.push(i);
				}
			})
			.catch(err => {
				console.error(err.message);
			});
	},
	methods: {
		scrollTo(year, index) {
			const options = {
				duration: 300,
				offset: 50,
				easing: "easeInOutCubic"
			};
			this.$vuetify.goTo(`#year-${year.substr(0,4)}`, options);
			//use substring to make Interaction Lab PhD dissertations scrollable
			this.panels.push(index);
		},
		goTop() {
			const options = {
				duration: 300,
				offset: 0,
				easing: "easeInOutCubic"
			};
			this.$vuetify.goTo("body", options);
		}
	}
};
</script>

<style lang="scss">
.publication {
	h4 {
		margin-bottom: 10px;
	}
}
</style>
